import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm, Field, Form } from 'redux-form';

import { TextField } from 'common/components/forms';
import { Layout, Title, FormError } from 'common/components/layout';
import SubMenu from 'profile/common/SubMenu';
import { editPassword } from 'redux/customer/actions';
import { asyncValidatePassword } from 'redux/customer/helpers';

import { validatePassword } from './validators';

class PasswordEdit extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    delete data.confirmPassword;
    const successFunction = () => {
      props.history.push('/profile/account');
    };
    props.editPassword(data, successFunction);
  };

  render() {
    const { settings, customer, form } = this.props;
    const { handleSubmit } = this.props;
    if (!settings.data || !customer.data) {
      return (
        <Layout title="Edit Account Password" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    return (
      <Layout title="Edit Account Password">
        <Title>Your Account</Title>
        <SubMenu />

        <div className="c7-account__information">
          <h2>Edit account password</h2>
          <Form
            onSubmit={handleSubmit(this.handleSubmit)}
            className="c7-form"
            method="post"
          >
            <FormError formName={form} />
            {customer.data.hasAccount && (
              <Field
                name="currentPassword"
                label="Current Password"
                formType="password"
                component={TextField}
                required
              />
            )}
            <Field
              name="password"
              label="New Password"
              formType="password"
              component={TextField}
              required
            />
            <Field
              name="confirmPassword"
              label="Confirm Password"
              formType="password"
              component={TextField}
              required
            />
            <div className="c7-form__button-row">
              <Link to="/profile/account" className="c7-button-alt">
                Cancel
              </Link>
              <button type="submit" className="c7-button">
                Update Password
              </button>
            </div>
          </Form>
        </div>
      </Layout>
    );
  }
}

const transformData = (values) => {
  const data = {
    currentPassword: values.currentPassword,
    password: values.password,
    confirmPassword: values.confirmPassword
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validatePassword(data);
  return errors;
};

const mapStateToProps = (state) => ({
  settings: state.setting,
  customer: state.customer
});

const asyncValidate = (values) => {
  const { password } = values;
  return asyncValidatePassword(password).then((errors) => {
    if (errors) {
      throw errors;
    }
  });
};

PasswordEdit = reduxForm({
  form: 'passwordEdit',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate,
  asyncValidate,
  asyncBlurFields: ['password']
})(PasswordEdit);

export default connect(mapStateToProps, { editPassword })(PasswordEdit);
